import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { FlexColumn } from 'ui-components/components/flex/column';
import { Gap } from 'ui-components/components/flex/gap';
import { Checkbox } from 'ui-components/components/checkbox';
import { Text, TextType } from 'ui-components/components/text';
import { InlineMessage, INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';

import { getErrorMessage } from '../../../../validation/utilities';
import type { ValidationError } from '../../../../validation/validation-error';
import { messages } from './messages';
import { WwexTermsDisplay } from './wwex-terms-display';

type TermsSectionProps = {
  isAccepted: boolean;
  isDisabled: boolean;
  error?: ValidationError;
  onAcceptChange: (accepted: boolean) => void;
};

export const TermsSection = ({ isAccepted, isDisabled, error, onAcceptChange }: TermsSectionProps) => {
  const intl = useIntl();

  const handleChange = useCallback(() => {
    onAcceptChange(!isAccepted);
  }, [isAccepted, onAcceptChange]);

  const errorMessage = getErrorMessage(error);

  return (
    <FlexColumn gap={Gap.Space12}>
      <Text textType={TextType.H4} value={messages.termsSectionTitle} />

      <WwexTermsDisplay />

      <FlexColumn>
        <Checkbox
          checked={isAccepted}
          disabled={isDisabled}
          label={intl.formatMessage(messages.termsCheckboxLabel)}
          onChange={handleChange}
        />
        {errorMessage && <InlineMessage type={INLINE_MESSAGE_TYPES.error}>{errorMessage}</InlineMessage>}
      </FlexColumn>
    </FlexColumn>
  );
};
